import React from 'react';
import { styled } from 'styled-components';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { addPersistingQueryParamsToPath } from '../helpers/urlHelper';

export interface QuestionLinkProps {
  token?: string;
  buttonType?: 'primary' | 'emphasised';
}

const QuestionSection = styled.div`
  margin-top: 4em;
`;

const StyledButton = styled(Button)`
  margin: 20px auto;
`;

const QuestionLink: React.FC<QuestionLinkProps> = ({ token, buttonType }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const path = `/questions/?token=${token}`;
  return (
    <QuestionSection data-cy="additional-info-section">
      <Text tagName="h2" textStyle="Heading.S">
        {t('pages.confirm.questionTitle')}
      </Text>
      <Text tagName="p" textStyle="Body.L">
        {t('pages.confirm.questionDescription')}
      </Text>
      <StyledButton
        type={buttonType}
        onClick={() =>
          navigate(
            addPersistingQueryParamsToPath(path, {
              addToExistingQueryParam: true,
              exclude: ['vpc', 'projectid', 'imagination', 'event_action'],
            }),
          )
        }
        text={t('pages.confirm.questionButtonTitle')}
        data-cy="additional-info-button"
      />
    </QuestionSection>
  );
};

export default QuestionLink;
